"use strict";
/**
 * Scan Result Enums
 *
 * Represents the outcome of content scanning operations.
 * Multiple scan result enums exist because different subsystems
 * use different sets of values.
 *
 * Consumers: lambda-main, lambda-secure, lambda-utilities, free-pattern-warehouse-website
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MaterialScanResult = exports.PublishScanResult = exports.DatabaseScanResult = void 0;
/**
 * Database-level scan result for moderation queue items.
 * Used in moderation-unified.ts BaseModerationItem and moderation.ts DatabaseScanResult.
 */
var DatabaseScanResult;
(function (DatabaseScanResult) {
    DatabaseScanResult["PASSED"] = "passed";
    DatabaseScanResult["NEEDS_REVIEW"] = "needs_review";
    DatabaseScanResult["FAILED"] = "failed";
})(DatabaseScanResult || (exports.DatabaseScanResult = DatabaseScanResult = {}));
/**
 * Publish-level scan result for pattern publishing workflow.
 * Used in moderation.ts ScanResult and ModerationSnapshotRecord.
 */
var PublishScanResult;
(function (PublishScanResult) {
    PublishScanResult["PASSED"] = "passed";
    PublishScanResult["WARNING"] = "warning";
    PublishScanResult["FAILED"] = "failed";
})(PublishScanResult || (exports.PublishScanResult = PublishScanResult = {}));
/**
 * Material-specific scan result for material contribution workflow.
 * Used in material-contribution.ts MaterialScanResult.
 */
var MaterialScanResult;
(function (MaterialScanResult) {
    MaterialScanResult["PASSED"] = "passed";
    MaterialScanResult["FLAGGED"] = "flagged";
    MaterialScanResult["REJECTED"] = "rejected";
})(MaterialScanResult || (exports.MaterialScanResult = MaterialScanResult = {}));
